module.exports = __webpack_public_path__ + "img/403forbidden.ba6d5489.png";